import { useContext, useEffect, useState, useCallback } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import "../../newSidebar.css";
import "./SidBarClient.css";
import { MagasinContext } from "../../../Context/MagasinContext";

/* ── Icons ────────────────────────────────────────────────── */
const HomeIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
    <polyline points="9 22 9 12 15 12 15 22" />
  </svg>
);

const HistoriqueIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

const AssistanceIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>
);

const TicketIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
    <line x1="1" y1="10" x2="23" y2="10" />
  </svg>
);

const SettingsIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-2 2 2 2 0 01-2-2v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 01-2-2 2 2 0 012-2h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 012-2 2 2 0 012 2v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 012 2 2 2 0 01-2 2h-.09a1.65 1.65 0 00-1.51 1z" />
  </svg>
);

const LogoutIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </svg>
);

/* ── Component ────────────────────────────────────────────── */
export default function SidBarClient() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);
  const [cartCount, setCartCount] = useState<number>(0);

  const magasinContext = useContext(MagasinContext);
  const ClientId = localStorage.getItem("ClientId");
  const ClientName = localStorage.getItem("ClientName");

  const idClient = ClientId || magasinContext.id?.id;
  const NameClient = ClientName || magasinContext.id?.NomMagasin;
  const initials = NameClient?.charAt(0)?.toUpperCase() ?? "C";

  const isMobile = screenWidth <= 768;

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const updateCartCount = useCallback(() => {
    const stored = localStorage.getItem("productsClient");
    if (!stored) {
      setCartCount(0);
      return;
    }
    try {
      const parsed = JSON.parse(stored);
      setCartCount(Array.isArray(parsed) ? parsed.length : 0);
    } catch {
      setCartCount(0);
    }
  }, []);

  useEffect(() => {
    updateCartCount();
    window.addEventListener("panier-updated", updateCartCount);
    return () => window.removeEventListener("panier-updated", updateCartCount);
  }, [updateCartCount]);

  // Set CSS offset variable so page content doesn't go under the sidebar
  useEffect(() => {
    const offset = isMobile ? "0px" : isCollapsed ? "80px" : "220px";
    document.documentElement.style.setProperty("--app-sidebar-offset", offset);
    document.body.classList.add("app-has-sidebar");
    return () => {
      document.documentElement.style.removeProperty("--app-sidebar-offset");
      document.body.classList.remove("app-has-sidebar");
    };
  }, [isMobile, isCollapsed]);

  const navItems = [
    { path: `/clients/${idClient}`,            label: "Accueil",    Icon: HomeIcon       },
    { path: `/clients/${idClient}/historique`,  label: "Suivi",      Icon: HistoriqueIcon },
    { path: `/clients/${idClient}/assistance`,  label: "Assistance", Icon: AssistanceIcon },
    { path: `/clients/${idClient}/mes-tickets`, label: "Tickets",    Icon: TicketIcon     },
    { path: `/clients/${idClient}/paramétres`,  label: "Réglages",   Icon: SettingsIcon   },
  ];

  const isItemActive = (path: string) =>
    path === `/clients/${idClient}`
      ? location.pathname === path
      : location.pathname.startsWith(path);

  const getPageTitle = () => {
    const path = location.pathname;
    if (path === `/clients/${idClient}`) return "WYN";
    if (path === `/clients/${idClient}/historique`) return "Suivi Commandes";
    if (path === `/clients/${idClient}/assistance`) return "Assistance support";
    if (path === `/clients/${idClient}/mes-tickets`) return "Mes Tickets";
    if (path === `/clients/${idClient}/paramétres`) return "Paramètres";
    if (path.includes("/panier")) return "Mon Panier";
    if (path.includes("/articles/")) return "Détails Produit";
    return "WYN Boutique";
  };

  const isSubPage = ![`/clients/${idClient}`, `/clients/${idClient}/historique`, `/clients/${idClient}/assistance`, `/clients/${idClient}/mes-tickets`, `/clients/${idClient}/paramétres`].includes(location.pathname);

  /* ── MOBILE: Top Header + Bottom Navigation Bar ─────────── */
  if (isMobile) {
    return (
      <>
        {/* Unified Top App Bar */}
        <header className="cl-mobile-top-bar">
          <div className="cl-mobile-top-bar__left">
            {isSubPage ? (
              <button className="cl-mobile-top-bar__back" onClick={() => window.history.back()} aria-label="Retour">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="19" y1="12" x2="5" y2="12"></line>
                  <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
              </button>
            ) : (
              <div className="cl-mobile-top-bar__brand">
                <span className="cl-mobile-top-bar__logo">W<span>yn</span></span>
              </div>
            )}
          </div>
          
          <div className="cl-mobile-top-bar__title">{getPageTitle()}</div>

          <div className="cl-mobile-top-bar__right">
            {/* Notification Bell */}
            <button
              className="cl-mobile-top-bar__notif"
              onClick={() => navigate(`/clients/${idClient}/notification`)}
              aria-label="Notifications"
              title="Notifications"
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                <path d="M13.73 21a2 2 0 0 1-3.46 0" />
              </svg>
            </button>
            {/* Cart Icon */}
            {!location.pathname.includes("/panier") && (
              <button 
                className="cl-mobile-top-bar__cart" 
                onClick={() => cartCount === 0 ? navigate(`/clients/${idClient}`) : navigate(`/client/${idClient}/panier`)}
                aria-label="Panier"
              >
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <circle cx="9" cy="21" r="1"></circle>
                  <circle cx="20" cy="21" r="1"></circle>
                  <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                </svg>
                {cartCount > 0 && <span className="cl-mobile-top-bar__badge">{cartCount}</span>}
              </button>
            )}
            {/* Logout Button */}
            <button
              className="cl-mobile-top-bar__notif text-danger"
              onClick={() => navigate("/logout")}
              aria-label="Déconnecter"
              title="Déconnecter"
              style={{ color: '#ef4444' }}
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                <polyline points="16 17 21 12 16 7" />
                <line x1="21" y1="12" x2="9" y2="12" />
              </svg>
            </button>
          </div>
        </header>

        {/* Mobile Bottom Navigation Bar */}
        <nav className="cl-bottom-nav" aria-label="Navigation principale">
          {navItems.map(({ path, label, Icon }) => (
            <NavLink
              key={path}
              to={path}
              className={`cl-bottom-nav__item ${isItemActive(path) ? "cl-bottom-nav__item--active" : ""}`}
              end={path === `/clients/${idClient}`}
            >
              <span className="cl-bottom-nav__icon"><Icon /></span>
              <span className="cl-bottom-nav__label">{label}</span>
            </NavLink>
          ))}
        </nav>
      </>
    );
  }

  /* ── DESKTOP: Sidebar ───────────────────────────────────── */
  return (
    <aside className={`cl-sidebar ${isCollapsed ? "cl-sidebar--collapsed" : ""}`}>
      {/* Toggle button */}
      <button
        className="cl-sidebar__toggle"
        onClick={() => setIsCollapsed(!isCollapsed)}
        aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
      >
        <i className={`bi ${isCollapsed ? "bi-chevron-right" : "bi-chevron-left"}`} />
      </button>

      {/* Avatar / User */}
      <div className="cl-sidebar__profile">
        <div className="cl-sidebar__avatar">{initials}</div>
        {!isCollapsed && (
          <div className="cl-sidebar__user-info">
            <span className="cl-sidebar__user-name">{NameClient}</span>
            <span className="cl-sidebar__user-role">Client</span>
          </div>
        )}
      </div>

      {/* Navigation items */}
      <nav className="cl-sidebar__nav">
        {navItems.slice(0, 4).map(({ path, label, Icon }) => (
          <NavLink
            key={path}
            to={path}
            title={isCollapsed ? label : ""}
            className={`cl-sidebar__nav-item ${isItemActive(path) ? "cl-sidebar__nav-item--active" : ""}`}
            end={path === `/clients/${idClient}`}
          >
            <span className="cl-sidebar__nav-icon"><Icon /></span>
            {!isCollapsed && <span className="cl-sidebar__nav-label">{label}</span>}
          </NavLink>
        ))}
      </nav>

      {/* Bottom actions */}
      <div className="cl-sidebar__footer">
        <NavLink
          to={`/clients/${idClient}/paramétres`}
          title={isCollapsed ? "Réglages" : ""}
          className={`cl-sidebar__nav-item ${location.pathname.includes("paramétres") ? "cl-sidebar__nav-item--active" : ""}`}
        >
          <span className="cl-sidebar__nav-icon"><SettingsIcon /></span>
          {!isCollapsed && <span className="cl-sidebar__nav-label">Réglages</span>}
        </NavLink>
        <NavLink
          to="/logout"
          className="cl-sidebar__logout"
          title={isCollapsed ? "Déconnecter" : ""}
        >
          <span className="cl-sidebar__nav-icon"><LogoutIcon /></span>
          {!isCollapsed && <span className="cl-sidebar__nav-label">Déconnecter</span>}
        </NavLink>
      </div>
    </aside>
  );
}